import { Base } from '../base-component';
import './cta-with-image.component.scss';

export class CtaWithImage extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/cta-with-image/cta-with-image.component.ts